import { useMemo } from 'react'
import { OperatingHoursRange, ProcessSegmentsOptions } from './types'
import { getGroupedWeekdaysWithSegments, processTimeRangesToWeekdaysWithSegments } from './utils'

export const useOperatingHoursWeekdaySegments = (
  timeRanges: OperatingHoursRange[],
  options: ProcessSegmentsOptions,
) => {
  const weekdaysWithSegments = useMemo(
    () => processTimeRangesToWeekdaysWithSegments(timeRanges, options),
    [options, timeRanges],
  )

  const groupedWeekdaysWithSegments = useMemo(
    () => getGroupedWeekdaysWithSegments(weekdaysWithSegments),
    [weekdaysWithSegments],
  )

  return groupedWeekdaysWithSegments
}
